import { render, staticRenderFns } from "./PlaceSearch.vue?vue&type=template&id=06e74042"
import script from "./PlaceSearch.vue?vue&type=script&lang=js"
export * from "./PlaceSearch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports